/**
 * Maps a kebab-case fl-icon `name` (e.g. `ui-trophy`, `cool-bell`,
 * `flicon-community`) to the camelCase export key used in `fl-icons.ts`
 * (e.g. `flTrophy`, `coolBell`, `flFliconCommunity`).
 *
 * Naming rule:
 *   ui-foo-bar    → flFooBar       (strip `ui-`, prepend `fl`)
 *   cool-foo      → coolFoo        (camelCase as-is, no `fl` prefix —
 *                                   matches @ng-icons/coolicons export names;
 *                                   flags externally-sourced set distinct from
 *                                   native fl icons)
 *   anything-else → flAnythingElse (prepend `fl`, camelCase whole name,
 *                                   including `flicon-foo` → `flFliconFoo`)
 *
 * Shared between the codegen (`scripts/generate-fl-icons.ts`) and the runtime
 * registry lookup in `icon.component.ts` — keep callers in sync by importing
 * from here.
 */
export function iconNameToConstName(name: string): string {
  let stem: string;
  let prefix: string;
  if (name.startsWith('ui-')) {
    stem = name.slice(3);
    prefix = 'fl';
  } else if (name.startsWith('cool-')) {
    stem = name;
    prefix = '';
  } else {
    stem = name;
    prefix = 'fl';
  }
  const camel = stem
    .split('-')
    .filter(Boolean)
    .map((part, i) =>
      prefix === '' && i === 0
        ? part
        : part.charAt(0).toUpperCase() + part.slice(1),
    )
    .join('');
  return `${prefix}${camel}`;
}
